// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2zIoo","empty":"ModalGraph_empty__10CF8"};